export class NotificationParameterDTO{
  public FK_Company : number;
  public IsSystemNotification : boolean;
  public Message : string;
  public Title : string;
  public NotificationType : NotificationTypeEnum
  public Link : string;
  public ExpireDate : Date
}


export enum NotificationTypeEnum
{
  EMERGENCY = 1,
  MAINTENANCE = 2,
  RELEASE = 3,
  NOTICE = 4
}
